export class UserListingDto {
    Id: number;
    Name: string;
    Email: string;
    RoleName: string;

    constructor() { }

    matchesFilter(role: any): boolean {
        // Role filter
        if (role && role.length > 0 && !role.includes(this.RoleName)) return false;
        return true;
    }
}
